import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid-flex flex-column loading_main" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-2 pt-10 d-flex justify-content-center align-items-center fs-c-6 align-items-center access-denied" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gold" }, " Error Occured! ")
], -1)
const _hoisted_3 = { class: "text-center fs-c-6 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "text-white" }, "Please click the link to refresh.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backDealer()))
      }, " Back ")
    ])
  ]))
}